import dayjs from 'dayjs';

/**
 * Service for consistent date formatting across fiability module.
 * Centralizes date formatting logic currently duplicated in 8+ components.
 */
export default class DateFormatterService {
  /**
   * Format date to DD-MM-YYYY
   * @param value - Date value (Date, string, or timestamp)
   * @param defaultValue - Value to return if date is null/undefined
   */
  public formatDate(value: any, defaultValue: string = ''): string {
    if (!value) {
      return defaultValue;
    }
    return dayjs(value).format('DD-MM-YYYY');
  }

  /**
   * Format date to DD-MM-YYYY HH:mm
   */
  public formatDateTime(value: any, defaultValue: string = ''): string {
    if (!value) {
      return defaultValue;
    }
    return dayjs(value).format('DD-MM-YYYY HH:mm');
  }

  /**
   * Format date for ISO string (API calls)
   */
  public toISODate(value: any): string | null {
    if (!value) {
      return null;
    }
    return dayjs(value).toISOString();
  }

  /**
   * Parse date from string
   */
  public parseDate(value: string): Date | null {
    if (!value) {
      return null;
    }
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.toDate() : null;
  }
}
